import { Domain } from '../domains/domain';

export class Letterhead {
  public id?: string;
  public name: string;
  public domain?: Domain;
  public url: string;
}
